var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var validSlugChars = '0123456789-abcdefghijklmnopqrstuvwxyz';
var validSlugCharMap = validSlugChars.split('').reduce(function (acc, c) {
    var _a;
    return (__assign(__assign({}, acc), (_a = {}, _a[c] = true, _a)));
}, {});
var isValidSlugChar = function (char) { return validSlugCharMap[char] || false; };
export function slugifyBrand(brand) {
    return brand.replace(/[-,]/g, '')
        .trim()
        .replace(/\s/g, '-')
        .toLowerCase()
        .replace(/ä/g, 'a')
        .replace(/ö/g, 'o')
        .replace(/å/g, 'a')
        .replace(/[éè]/g, 'e')
        .replace(/\+/g, '-plus-')
        .replace(/&/g, '-et-')
        .replace(/\//g, '-') // '/' -> '-'
        .replace(/-+/g, '-') // collapse multiple dashes to one
        .split('').filter(isValidSlugChar).join('');
}
